import { IMasterInsuranceInitialValues } from '../../../types';

export const INITIAL_VALUES: IMasterInsuranceInitialValues = {
  id: undefined,
  upload_files: [],
  email_users: [],
  organization: 0,
  policy_number: undefined,
  start_date: '',
  end_date: '',
  description: '',
  branch: '',
  recent_status: '',
};
